class AddNavSpanClasses {
  constructor() {
    this.menu = document.querySelector('.navMain');
    this.events();
  }

  events() {
    this.menu.childNodes.forEach(item => {
      if (item.nodeType === Node.ELEMENT_NODE) {
        if (item.classList.contains('ico')) {
          item.children[0].children[0].classList.add(item.classList[0]); // legger til 'ico' class på ikon
          item.children[0].children[0].classList.add(item.classList[1]); // legger til spesifikt icon-class
        }
        if (item.classList.contains('menu-item-has-children')) {
          item.childNodes.forEach(menu => {
            if (menu.nodeType === Node.ELEMENT_NODE) {
              if (menu.classList.contains('navMain__submenu')) {
                menu.childNodes.forEach(subitem => {
                  if (subitem.nodeType === Node.ELEMENT_NODE) {
                    if (subitem.classList.contains('ico')) {
                      subitem.children[0].children[0].classList.add(subitem.classList[0]);
                      subitem.children[0].children[0].classList.add(subitem.classList[1]);
                    }
                    if (subitem.classList.contains('menu-item-has-children')) {
                      subitem.childNodes.forEach(subsub => {
                        if (subsub.nodeType === Node.ELEMENT_NODE && subsub.classList.contains('navMain__submenu')) {
                          subsub.childNodes.forEach(subsubitem => {
                            if (subsubitem.nodeType === 1 && subsubitem.classList.contains('ico')) {
                              subsubitem.children[0].children[0].classList.add(subsubitem.classList[0]);
                              subsubitem.children[0].children[0].classList.add(subsubitem.classList[1]);
                            }
                          })
                        }
                      })
                    }
                  }
                });

              }
            }
          })
        }
      }
    })
  }
}

export default AddNavSpanClasses